const FETCH_CASE_NO_PRINCIPALS = 'fetch_caseNoPrincipals';
const FETCH_CASE_NO_PRINCIPALS_CSV = 'fetch_caseNoPrincipals_csv';
const FETCH_CASE_NO_PRINCIPAL = 'fetch_caseNoPrincipal';
const DELETE_CASE_NO_PRINCIPAL = 'delete_caseNoPrincipal';
const PERSIST_CASE_NO_PRINCIPAL = 'persist_caseNoPrincipal';
export default {
    FETCH_CASE_NO_PRINCIPALS,
    FETCH_CASE_NO_PRINCIPALS_CSV,
    FETCH_CASE_NO_PRINCIPAL,
    DELETE_CASE_NO_PRINCIPAL,
    PERSIST_CASE_NO_PRINCIPAL,
};
